module.exports = __webpack_public_path__ + "static/glass-mockup-holder-629977c9307a3f9671da7ca9c0ed827b.webp";